import { type ComparisonBarDatum } from './ComparisonBarChart';
import { ComparisonRows } from './ComparisonRows';

export type ComparisonVolumeChartProps = {
    data: ComparisonBarDatum[];
    formatValue?: (value: number) => string;
    onBarClick?: (datum: ComparisonBarDatum) => void;
    visibleRefIndices?: number[];
    baselineColor?: string;
};

export function ComparisonVolumeChart(props: ComparisonVolumeChartProps) {
    return <ComparisonRows {...props} view="volume" />;
}
